import React from "react";
import { useNavigate } from "react-router";
import SecondaryButton from "../buttons/SecondaryButton";

export const BackButton = ({editLocation,editTrial,classes}) => {
    const navigate = useNavigate()
    const handleBack = () => {
        navigate(editLocation?'/locations':editTrial?'/trials':-1); // This goes back to the previous screen
    };
    return <SecondaryButton label="Cancel" onClick={handleBack} classes={classes} />
};